export const getNotifications = state => state
export const getToastIdByIdNotification = (state, id) =>
  state.find(notification => notification.id === id).toastId
